<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.serial_number.search_serial_number' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="search-row">
        <div class="search-input">
            <hub-input [(ngModel)]="serialNumber" [iconColor]="'#888888'" [icon]="'scan'" [autofocus]="true"
                [allowClear]="true"
                placeholder="{{ 'bikeshop.workshop.jobcard.serial_number.serial_number_placeholder' | translate }}"></hub-input>
        </div>
        <hub-button [text]="'bikeshop.workshop.jobcard.serial_number.search' | translate" [style]="'secondary'"
            [icon]="'search'" [size]="'md'" [disabled]="!serialNumber || isloading" (buttonClick)="search()">
        </hub-button>
    </div>
</div>
<div class="modal-footer-container" *ngIf="resultCount==0">
  <div class="short-cut-container">
    {{ 'bikeshop.modal.shedule_service.search_no_matches' | translate }}

    <hub-button class=" f-right "
                [title]="'bikeshop.modal.shedule_service.schedule_service' | translate"
                [text]="'bikeshop.modal.shedule_service.schedule_service' | translate"
                [style]="'secondary'"
                [size]="'md'" [icon]="'memo-pencil'" (buttonClick)="scheduleService()">
    </hub-button>
  </div>
</div>
<div class="modal-footer-container">
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'"
                [color]="'#6B728C'"></daz-icon></span>{{ 'bikeshop.workshop.jobcard.serial_number.to_search' | translate }}
    </div>
</div>
